
import TokenPreviewWrapper from './tokenpreviewwrapper'

export default TokenPreviewWrapper;